export default {
	computed: {
		basket () {
			return this.$store.getters['iOrderCore/getBasket'];
		},
		basketCount () {
			return this.$store.getters['iOrderCore/getBasketCount']
		},
		basketTotal () {
			if(!this.$store.getters['iOrderCore/getBasket'].lines.length) return '0.00';
			return this.$store.getters['iOrderCore/getBasketTotal'];
		}
	},
	methods: {
		cgIndex (productId, choiceGroupId) {
			const aztecProduct = this.$store.getters['iOrderCore/getProduct'](productId);
			return aztecProduct.portions[0].choices.findIndex(choiceGroup => {
				return choiceGroup.choiceId === choiceGroupId;
			})
		},
		editBasketChoices (choicesArray, basketIndex) {
			return this.$store.dispatch('iOrderCore/editBasketChoices',{
				basketIndex,
				choicesArray
			});
		},
		decrementBasketItem (lineItem) {
			this.$store.dispatch('iOrderCore/removeItemFromBasket', { lineItem });
		},
		getBasketIndex (lineItem) {
			return this.$store.getters['iOrderCore/getBasketIndex'](lineItem);
		},
		getCG (groupId) {
			return this.$store.getters['iOrderCore/getChoiceGroup'](groupId) || {}
		},
		getItemCount (productId) {
			return this.$store.getters['iOrderCore/getItemCount'](productId);
		},
		getKeyWord (keywordId) {
			return this.$store.getters['iOrderCore/getKeyWord'](keywordId) || {}
		},
		getProduct (productId) {
			return this.$store.getters['iOrderCore/getProduct'](productId) || {}
		},
		incrementBasketItem (product, quantity, choicesArray) {
			if (this.getItemCount(product.id) >= 10) return false;
			return this.$store.dispatch('iOrderCore/incrementBasketItem', { product, quantity, choicesArray });
		}
	}
}
